import { Component, OnInit, inject, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from "../../../modal/modal.component";
import { InicioService } from '../../../../services/inicio.service';
import { PlanificacionCumplimientoService } from '../../../../services/planificacion-cumplimiento.service';

@Component({
  selector: 'app-lista-aspirante',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule],
  templateUrl: './lista-aspirante.component.html',
  styleUrl: './lista-aspirante.component.css'
})
export class ListaAspiranteComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Output() atras = new EventEmitter<any>();
  @Input() organizacion?: string;
  @Input() aspirantes?: any;
  @Input() sucursal?: any;
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  filteredResultado: any = []; // Nuevo array para los resultados filtrados
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda

  private srvLogin = inject(InicioService);
  private servicios = inject(PlanificacionCumplimientoService);
  private modalService = inject(NgbModal);
  private contentCargando: NgbModalRef | undefined;


  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });

    console.log('prueba:  ',this.aspirantes)

    this.filteredResultado = [...this.aspirantes]; // Actualiza los resultados filtrados al cambiar el año
  }

  buscarAspirante() {
    this.filteredResultado = this.aspirantes.filter((item: any) => {
      const nombre = item.aspirante ? this.quitarAcentos(item.aspirante.toLowerCase()) : '';
      const estado = item.estado ? this.quitarAcentos(item.estado.toLowerCase())  : '';
      const term = this.searchTerm.toLowerCase();
      return (
        nombre.includes(term)  ||
        estado.includes(term)
      );
    });
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  cargar(){

    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    const valoresSeleccionados: any = [];

    checkboxes.forEach((checkbox: any) => {
      if (checkbox.checked) valoresSeleccionados.push(parseInt(checkbox.value));
    });
    // Aquí puedes hacer lo que necesites con los valores seleccionados

    if(valoresSeleccionados.length > 0){
      //let envior = {'usuario_sesion': this.user.id_institucional,  'menus': valoresSeleccionados  }
      console.log('Valores seleccionados:', valoresSeleccionados);
    }
    else{
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Debe selecionar al menos un aspirante.';
      this.mdl.alerta();
    }

  }


  seleccionOcupacion(id_participante: string){
    console.log('prueba:  ',id_participante)
  }


  volver(){
    this.atras.emit({value: false, validador: false});
  }

}
